import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["verbalDate", "handleVerbalDateChange", "severity", "error"];
import React from 'react';
import { ErrorLabel, VerbalPicker } from './components/components';
import { SuggestBoxWrapper, StatementText } from './layout/WrapperDiv';
import { infoWidth } from './components/constants';
import en from '../translationDefaults/en';
export const OrderVerbalDatePick = _ref => {
  let {
    verbalDate,
    handleVerbalDateChange,
    severity,
    error
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StatementText, {
    id: "verify-verbal-date-check"
  }, /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    width: infoWidth
  }, en.verifyVerbalReceived), /*#__PURE__*/React.createElement(VerbalPicker, _extends({
    unsetPopperStyles: true,
    width: 195,
    selectedDate: verbalDate,
    handleVerbalDateChange: handleVerbalDateChange,
    severity: severity
  }, props)), error && /*#__PURE__*/React.createElement(ErrorLabel, {
    errorLabel: error
  }));
};
export default OrderVerbalDatePick;